import { render, staticRenderFns } from "./EditModelo.vue?vue&type=template&id=b58369f0"
import script from "./EditModelo.vue?vue&type=script&lang=js"
export * from "./EditModelo.vue?vue&type=script&lang=js"
import style0 from "./EditModelo.vue?vue&type=style&index=0&id=b58369f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports